var _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _radialGradient8, _radialGradient9, _linearGradient, _radialGradient10, _linearGradient2, _radialGradient11, _radialGradient12, _radialGradient13, _radialGradient14, _radialGradient15, _radialGradient16, _radialGradient17, _radialGradient18, _radialGradient19, _linearGradient3, _radialGradient20, _radialGradient21, _radialGradient22, _linearGradient4, _radialGradient23, _radialGradient24, _radialGradient25, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPolaroid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 70.438,
    cy: 414.517,
    gradientTransform: "matrix(1 0 0 .853 0 60.9)",
    gradientUnits: "userSpaceOnUse",
    r: 125.133
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#90d8f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4731,
    stopColor: "#6bbef6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5888,
    stopColor: "#66b5eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7907,
    stopColor: "#5a9ece"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a80aa"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 49.043,
    cy: 101.785,
    gradientTransform: "matrix(.36 .933 -.546 .211 87.005 34.576)",
    gradientUnits: "userSpaceOnUse",
    r: 325.185
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0132,
    stopColor: "#ecf4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1054,
    stopColor: "#e5f3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3496,
    stopColor: "#d8f0fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5693,
    stopColor: "#d3effb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5856,
    stopColor: "#d0eefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8616,
    stopColor: "#a2defa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90d8f9"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 343.421,
    cy: 304.091,
    gradientTransform: "matrix(-1 0 0 -.982 686.841 602.706)",
    gradientUnits: "userSpaceOnUse",
    r: 414.824
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.598e-8,
    stopColor: "#90d8f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3919,
    stopColor: "#6bbef6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4934,
    stopColor: "#65b3e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6866,
    stopColor: "#5495c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8925,
    stopColor: "#407093"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 1074.5,
    cy: 431.488,
    gradientTransform: "matrix(.069 0 0 .106 41.338 9.411)",
    gradientUnits: "userSpaceOnUse",
    r: 660.302
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0132,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6064,
    stopColor: "#f1f1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#ededf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9641,
    stopColor: "#e2e0e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dfdde2"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 306.146,
    cy: 274.377,
    gradientTransform: "matrix(-.662 0 0 .59 503.83 -52.432)",
    gradientUnits: "userSpaceOnUse",
    r: 331.29
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0544,
    stopColor: "#f1f1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5398,
    stopColor: "#dfdde2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8108,
    stopColor: "#c3bfc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9823,
    stopColor: "#afaab4"
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: 287.266,
    cy: 291.522,
    gradientTransform: "matrix(-.662 0 0 .419 478.845 -18.642)",
    gradientUnits: "userSpaceOnUse",
    r: 236.035
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6e266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3819,
    stopColor: "#f2d53b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#f1d333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8691,
    stopColor: "#e7a627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9864,
    stopColor: "#e49824"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: 194.988,
    cy: 146.398,
    gradientTransform: "matrix(-.887 0 0 1.134 566.234 7.099)",
    gradientUnits: "userSpaceOnUse",
    r: 40.981
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0132,
    stopColor: "#fffbe4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6064,
    stopColor: "#f9efaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6965,
    stopColor: "#f9eeab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#f8ec9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8852,
    stopColor: "#f7e88a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#f6e36d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6e266"
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: 214.954,
    cy: 162.805,
    gradientTransform: "matrix(.887 0 0 -1.134 184.983 411.788)",
    gradientUnits: "userSpaceOnUse",
    r: 41.393
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6e266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1284,
    stopColor: "#f4dc61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3004,
    stopColor: "#f0cb55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4973,
    stopColor: "#e9af40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7111,
    stopColor: "#e08823"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7226,
    stopColor: "#df8621"
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_9_",
    cx: 167.462,
    cy: 157.102,
    gradientTransform: "matrix(-.887 0 0 1.134 566.234 30.141)",
    gradientUnits: "userSpaceOnUse",
    r: 56.133
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbf4c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3542,
    stopColor: "#f8ec9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5523,
    stopColor: "#f6e781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9864,
    stopColor: "#ecbe6b"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfdde2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6376,
    stopColor: "#756e78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7682,
    stopColor: "#716b74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8863,
    stopColor: "#666069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    stopColor: "#544f57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544f57"
  }))), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_10_",
    cx: 193.41,
    cy: 212.28,
    gradientTransform: "matrix(.707 -.707 .655 .655 -82.339 210.054)",
    gradientUnits: "userSpaceOnUse",
    r: 174.984,
    xlinkHref: "#lg1"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#756e78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1679,
    stopColor: "#6f6872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3924,
    stopColor: "#5e5861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4937,
    stopColor: "#544f57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454045"
  }))), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_11_",
    cx: 141.067,
    cy: 304.772,
    gradientTransform: "matrix(1 0 0 .66 0 103.539)",
    gradientUnits: "userSpaceOnUse",
    r: 218.949,
    xlinkHref: "#lg2"
  })), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_12_",
    cx: 335.44,
    cy: 319.991,
    gradientUnits: "userSpaceOnUse",
    r: 196.832
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b818e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5622,
    stopColor: "#665e66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#615961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#514b51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454045"
  }))), _radialGradient13 || (_radialGradient13 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_13_",
    cx: 132.234,
    cy: 155.842,
    gradientTransform: "matrix(.707 -.707 .655 .655 -63.305 147.31)",
    gradientUnits: "userSpaceOnUse",
    r: 46.562,
    xlinkHref: "#lg1"
  })), _radialGradient14 || (_radialGradient14 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_14_",
    cx: 118.306,
    cy: 180.453,
    gradientTransform: "matrix(1 0 0 .66 0 61.305)",
    gradientUnits: "userSpaceOnUse",
    r: 58.26,
    xlinkHref: "#lg2"
  })), _radialGradient15 || (_radialGradient15 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_15_",
    cx: 172.381,
    cy: 181.56,
    gradientUnits: "userSpaceOnUse",
    r: 70.043
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b818e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1855,
    stopColor: "#837985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#6d646d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5615,
    stopColor: "#665e66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7093,
    stopColor: "#615961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8948,
    stopColor: "#514b51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454045"
  }))), _radialGradient16 || (_radialGradient16 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_16_",
    cx: 322.053,
    cy: 311.688,
    gradientUnits: "userSpaceOnUse",
    r: 89.674
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0567,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2246,
    stopColor: "#f9fdfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4381,
    stopColor: "#eaf7fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6497,
    stopColor: "#d3effb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7656,
    stopColor: "#ceedfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9103,
    stopColor: "#bee8fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b1e4f9"
  }))), _radialGradient17 || (_radialGradient17 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_17_",
    cx: 318.687,
    cy: 304.192,
    gradientUnits: "userSpaceOnUse",
    r: 89.674
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6376,
    stopColor: "#756e78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7682,
    stopColor: "#716b74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8863,
    stopColor: "#666069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    stopColor: "#544f57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544f57"
  }))), _radialGradient18 || (_radialGradient18 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_18_",
    cx: 312.336,
    cy: 301.4,
    gradientUnits: "userSpaceOnUse",
    r: 48.389
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0567,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4469,
    stopColor: "#f9fdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6497,
    stopColor: "#f4fbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7677,
    stopColor: "#eff9fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9151,
    stopColor: "#dff3fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d3effb"
  }))), _radialGradient19 || (_radialGradient19 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_19_",
    cx: 336.862,
    cy: 357.363,
    gradientUnits: "userSpaceOnUse",
    r: 127.939
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0541,
    stopColor: "#a298a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3005,
    stopColor: "#827983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4937,
    stopColor: "#665e66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454045"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbe2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4646,
    stopColor: "#b6e4fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5553,
    stopColor: "#b1e4f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6238,
    stopColor: "#abdef4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7148,
    stopColor: "#9bcde5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8183,
    stopColor: "#80b2cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9303,
    stopColor: "#5b8cab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407093"
  }))), _radialGradient20 || (_radialGradient20 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_20_",
    cx: 43.388,
    cy: 242.876,
    gradientTransform: "matrix(1 0 0 .681 0 77.59)",
    gradientUnits: "userSpaceOnUse",
    r: 73.764,
    xlinkHref: "#lg3"
  })), _radialGradient21 || (_radialGradient21 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_21_",
    cx: 43.388,
    cy: 286.965,
    gradientTransform: "matrix(1 0 0 .681 0 91.674)",
    gradientUnits: "userSpaceOnUse",
    r: 73.764,
    xlinkHref: "#lg3"
  })), _radialGradient22 || (_radialGradient22 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_22_",
    cx: 43.388,
    cy: 331.054,
    gradientTransform: "matrix(1 0 0 .681 0 105.759)",
    gradientUnits: "userSpaceOnUse",
    r: 73.764,
    xlinkHref: "#lg3"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbe2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2265,
    stopColor: "#b6defd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5553,
    stopColor: "#90d8f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6287,
    stopColor: "#8bd2f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7261,
    stopColor: "#7fc1e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8369,
    stopColor: "#69a6c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957,
    stopColor: "#4c80a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407093"
  }))), _radialGradient23 || (_radialGradient23 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_23_",
    cx: 43.388,
    cy: 375.143,
    gradientTransform: "matrix(1 0 0 .681 0 119.844)",
    gradientUnits: "userSpaceOnUse",
    r: 73.764,
    xlinkHref: "#lg4"
  })), _radialGradient24 || (_radialGradient24 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_24_",
    cx: 44.286,
    cy: 415.517,
    gradientTransform: "matrix(1 0 0 .681 0 132.742)",
    gradientUnits: "userSpaceOnUse",
    r: 72.94,
    xlinkHref: "#lg4"
  })), _radialGradient25 || (_radialGradient25 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_25_",
    cx: 313.548,
    cy: 1168.367,
    gradientTransform: "matrix(.931 0 0 .112 -38.569 357.028)",
    gradientUnits: "userSpaceOnUse",
    r: 207.462
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#90d8f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0194,
    stopColor: "#94d9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3415,
    stopColor: "#cdeefd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    stopColor: "#e4f6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m107.651 416.701-62.106 9.426c0 33.807 27.406 61.212 61.212 61.212h59.029z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.786 125.458h-59.029c-33.806 0-61.212 27.406-61.212 61.212v239.457h59.029z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.243 487.34h-239.457c-33.807 0-61.212-27.406-61.212-61.212v-239.458c0-33.807 27.406-61.212 61.212-61.212h239.457c33.807 0 61.212 27.406 61.212 61.212v239.457c.001 33.807-27.405 61.213-61.212 61.213z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.032 0h13.083l8.649 125.458h-21.732z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.115 0h274.853v125.458h-274.853z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.627 125.458v-92.946h209.829v92.946z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392.812 228.904 17.488-78.739h-14.416c-15.047 0-27.244 13.754-27.244 30.721v39.534z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368.639 220.421c0 16.967 12.198 30.721 27.244 30.721h14.417l-27.244-30.721z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410.3 150.165c15.047 0 27.244 12.198 27.244 27.244v46.488c0 15.047-12.198 27.244-27.244 27.244-15.047 0-27.244-12.198-27.244-27.244v-46.488c-.001-15.046 12.197-27.244 27.244-27.244z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.569 190.944h-44.311c-63.764 0-115.455 51.691-115.455 115.455l66.777 12.656z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.335 306.399h-58.532c0 63.764 51.691 115.455 115.455 115.455h44.311z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.569,
    cy: 306.399,
    fill: "url(#SVGID_12_)",
    r: 115.455
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.207 150.165h-11.791c-16.967 0-30.721 13.754-30.721 30.721l17.769 3.368z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.269 180.886h-15.575c0 16.967 13.754 30.721 30.721 30.721h11.791z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.207,
    cy: 180.886,
    fill: "url(#SVGID_15_)",
    r: 30.721
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379.963 306.399c0 43.138-41.616 77.247-66.394 77.247-3.633 0-7.209.613-10.71.133-38.071-5.22-67.399-37.875-67.399-77.38s29.328-72.16 67.399-77.38c3.501-.48 7.987.711 11.621.711 28.756-.001 65.483 33.53 65.483 76.669z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.859,
    cy: 306.399,
    fill: "url(#SVGID_17_)",
    r: 17.179
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.038,
    cy: 277.629,
    fill: "url(#SVGID_18_)",
    r: 26.487
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.569 228.29c-3.633 0-7.208.248-10.71.729 38.071 5.22 67.399 37.875 67.399 77.38s-29.328 72.16-67.399 77.38c3.501.48 7.077.729 10.71.729 43.138 0 78.109-34.97 78.109-78.109s-34.971-78.109-78.109-78.109z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.767 220.778h-27.223v-19.737h27.223c5.45 0 9.868 4.418 9.868 9.868 0 5.451-4.418 9.869-9.868 9.869z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.767 264.868h-27.223v-19.737h27.223c5.45 0 9.868 4.418 9.868 9.868 0 5.45-4.418 9.869-9.868 9.869z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.767 308.957h-27.223v-19.737h27.223c5.45 0 9.868 4.418 9.868 9.868 0 5.45-4.418 9.869-9.868 9.869z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.767 353.046h-27.223v-19.737h27.223c5.45 0 9.868 4.418 9.868 9.868 0 5.45-4.418 9.869-9.868 9.869z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.767 397.135h-27.223v-19.737h27.223c5.45 0 9.868 4.418 9.868 9.868 0 5.45-4.418 9.869-9.868 9.869z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 512c111.166 0 201.283-11.041 201.283-24.66h-402.566c0 13.619 90.117 24.66 201.283 24.66z",
    fill: "url(#SVGID_25_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPolaroid);
export default __webpack_public_path__ + "static/media/icon-polaroid.0771e1b3ab6a75e3f6fe20f5f7dd39ff.svg";
export { ForwardRef as ReactComponent };